import { render, staticRenderFns } from "./ListaAlunosPorTurmaRSituacao.vue?vue&type=template&id=6d99efb0"
import script from "./ListaAlunosPorTurmaRSituacao.vue?vue&type=script&lang=js"
export * from "./ListaAlunosPorTurmaRSituacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports